//export const baseUrl = "https://s10eeih326.execute-api.ap-south-1.amazonaws.com/uat/v1";
//export const baseUrl = "https://api.thelallantop.com/v1";
export const baseUrl = process.env.NEXT_PUBLIC_APP_API_URL + "/v1";
export const baseInternalUrl = process.env.NEXT_PUBLIC_APP_SSR_URL + "/v1";
export const baseUrlV2 = process.env.NEXT_PUBLIC_APP_API_URL + "/v2";
export const LIVE_TIME_OUT = 10000;
export const OTP_LIMIT = 3;
export const USER_LOGIN_LIMIT = 10;
export const TOTAL_TOPIC_COLUMN = 3;